// export const host = "http://localhost:8080";
export const host = "https://barberzajednica.com";
